// extracted by mini-css-extract-plugin
module.exports = {"buttonWrapper":"AssetDetailsButton_buttonWrapper__6m4GL","hovered":"AssetDetailsButton_hovered__kzRjJ"};